import type { Estado } from '../types/autorizacion';

export const GRANOS_CIERRE_DEFAULT = [
  'TRIGO',
  'SOJA',
  'MAIZ',
  'GIRASOL',
  'SORGO',
  'MANI',
] as const;

export const ESTADOS = [
  'Pendiente',
  'En proceso',
  'Aprobada',
  'Rechazada',
  'Cancelada',
] as const satisfies readonly Estado[];

export const ESTADOS_OPERATIVOS: Estado[] = [
  'Pendiente',
  'En proceso',
  'Aprobada',
  'Rechazada',
];

export const ESTADOS_FINALES: Estado[] = ['Aprobada', 'Rechazada', 'Cancelada'];

export const CIERRE_MONEDA_DEFAULT = 'ARS';
export const MOBILE_BREAK = 992;

export const AUTH_SESSION_KEY = 'dashboard_session_id';
export const AUTH_USER_KEY = 'dashboard_auth_user';
export const AUTH_VERIFY_URL = '/api/auth/verify';
export const AUTH_SESSION_URL = '/api/auth/session';
export const AUTH_LOGOUT_URL = '/api/auth/logout';

export const COL_COUNT = 13;
